module.exports = {
      id: "triangle-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.789192dd.svg#triangle-usage",
      toString: function () {
        return this.url;
      }
    }